import React, { useEffect, useState, Fragment, useRef } from 'react'
import {Card, Col, Container, Form, Row} from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { formato_rut, diaAnterior, diaPosterior, formatearNumero, isValidParam} from '../../../../common/Formatos'
import { limpiarRefAction } from '../../../../store/actions/proceso-judicial-action'
import Mensajes from '../../../mensajes'

const CartaCiaTercero = ({ formik, setPorcConvData, setPorcConvOldData, setMontoNetoCompara, setMirecobroSinFormato, showToast, setShowToast }) => {
  const fileRef = useRef();
  const data_proceso_extrajudicial = useSelector((state) => state.procesoExtrajudicialReducer)
  const { cfg_form14, datosGestionImplicado } = data_proceso_extrajudicial
  const data_judicial = useSelector((state) => state.procesoJudicialReducer)
  const { cleanRef } = data_judicial
  //Data de CIA
  const data_modal_cia = useSelector((state) => state.modalCartaCiaTerceroReducer)
  const {cfg_form16, parametros, datosCIATErcero, comboTipoVehiculos, comboMarcas, comboCompanias, montosInformados, respuestaModalCIA} = data_modal_cia

  const [open, setOpen] = React.useState(false)
  
  //Estados CIA Carta
  const [tipoVehiculoIM, setTipoVehiculoIM] = useState('')
  const [patenteIM, setPatenteIM] = useState('')
  const [marcaVehiculoIM, setMarcaVehiculoIM] = useState('')
  const [detalleDescripcionIM, setDetalleDescripcionIM] = useState('')
  const [idCompaniaIM, setIdCompaniaIM] = useState('')
  const [idSiniestroIM, setIdSiniestroIM] = useState('')
  const [fechaSiniestroIM, setFechaSiniestroIM] = useState('')
  const [fechaSiniestro, setFechaSiniestro] = useState("")
  const [fechaEnvioCarta, setFechaEnvioCarta] = useState('')
  const [convenio, setConvenio] = useState(0)
  const [convenioOld, setConvenioOld] = useState(0)
  const [miRecobro, setMiRecobro] = useState(0)
  const [recobroNoFormato, setRecobroNoFormato] = useState(0)
  const [miMontoNeto, setMiMontoNeto] = useState(0)
  const [fechaCartaMin, setFechaCartaMin]=useState('')
  const dispatch = useDispatch()

  useEffect(()=>{
    setMirecobroSinFormato(recobroNoFormato)

  },[recobroNoFormato])
  useEffect(()=>{
    if(cleanRef){
        fileRef.current.value = "";
        dispatch(limpiarRefAction(false))
    }
},[cleanRef])
  
useEffect(()=>{
  setMontoNetoCompara(miMontoNeto)
},[miMontoNeto])
  
useEffect(()=>{
  if (datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['FechaSiniestroIMFormat'])) {
      setFechaCartaMin(convertirFecha( datosCIATErcero.datosCIATErcero[0]['FechaSiniestroIMFormat']))
    } else {
      setFechaCartaMin(datosGestionImplicado && convertirFecha(datosGestionImplicado.datosGestionImplicado[0]["fechaSiniestroFormat"]))
    }     
},[datosCIATErcero, datosGestionImplicado])

useEffect(() => {
  
  setMiMontoNeto(montosInformados && montosInformados.montosInformados[0]['MontoCosto'])
  setPorcConvOldData( montosInformados &&  montosInformados.montosInformados[0]['PorConvenidoEntreCias'])
  
}, [montosInformados])

useEffect(() => {

  if (montosInformados && datosCIATErcero) {

    setTipoVehiculoIM(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['IdTipoVehiculo']) ? datosCIATErcero.datosCIATErcero[0]['IdTipoVehiculo'] : "")
    setPatenteIM(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['Patente']) ? datosCIATErcero.datosCIATErcero[0]['Patente'] : "")
    setMarcaVehiculoIM(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['IdMarca']) ? datosCIATErcero.datosCIATErcero[0]['IdMarca'] : "")
    setTipoVehiculoIM(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['IdTipoVehiculo']) ? datosCIATErcero.datosCIATErcero[0]['IdTipoVehiculo'] : "")
    setDetalleDescripcionIM(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['Descripcion']) ? datosCIATErcero.datosCIATErcero[0]['Descripcion'] : "")
    setIdCompaniaIM(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['IdCiaImplicado']) ? datosCIATErcero.datosCIATErcero[0]['IdCiaImplicado'] : "")
    setIdSiniestroIM(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['SiniestroIM']) ? datosCIATErcero.datosCIATErcero[0]['SiniestroIM'] : "")
    setFechaSiniestroIM(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['FechaSiniestroIMFormat']) ? convertirFecha(datosCIATErcero.datosCIATErcero[0]['FechaSiniestroIMFormat']) : "")
    setFechaEnvioCarta(datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['FechaEnvioCartaCobroFormat']) ? convertirFecha(datosCIATErcero.datosCIATErcero[0]['FechaEnvioCartaCobroFormat']) : "")

    if (montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobroEntreCias'])) {
      setMiRecobro(montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobroEntreCias']) ? 
      formatearNumero(montosInformados.montosInformados[0]['MontoRecobroEntreCias'], 
      !(isValidParam(montosInformados.montosInformados[0]['CodMoneda']) && montosInformados.montosInformados[0]['CodMoneda'] == 30001))
        : ''
      ) 
      setRecobroNoFormato(montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobroEntreCias']) ? montosInformados.montosInformados[0]['MontoRecobroEntreCias'] : '' )
      setConvenio(montosInformados && isValidParam(montosInformados.montosInformados[0]['PorConvenidoEntreCias']) ? montosInformados.montosInformados[0]['PorConvenidoEntreCias'] : '' )
    
    } else {
      let porcConvCia = montosInformados && isValidParam(montosInformados.montosInformados[0]['porcConvCia']) ? montosInformados.montosInformados[0]['porcConvCia'] : 100;
      let montoCosto = montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoCosto']) ? montosInformados.montosInformados[0]['MontoCosto'] : 0;
      setConvenio(porcConvCia);
      let montoRecobro = montoCosto && Math.round(montoCosto * porcConvCia / 100);
      setMiRecobro(formatearNumero(montoRecobro, false));    
      setRecobroNoFormato(montoRecobro);  
      setMirecobroSinFormato(montoRecobro);
    }
  }


  /*setMiRecobro(montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobroEntreCias']) ? 
    formatearNumero(montosInformados.montosInformados[0]['MontoRecobroEntreCias'], 
    !(isValidParam(montosInformados.montosInformados[0]['CodMoneda']) && montosInformados.montosInformados[0]['CodMoneda'] == 30001))
    : ''
  ) 
  setRecobroNoFormato(montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoRecobroEntreCias']) ? montosInformados.montosInformados[0]['MontoRecobroEntreCias'] : '' )
  setConvenio(montosInformados && isValidParam(montosInformados.montosInformados[0]['PorConvenidoEntreCias']) ? montosInformados.montosInformados[0]['PorConvenidoEntreCias'] : '' )
  
if (montosInformados && montosInformados.montosInformados[0]['MontoRecobroEntreCias'] === null &&  montosInformados.montosInformados[0]['MontoRecobroEntreCias'] === ''){
  setConvenio(75)
  setMiRecobro(miMontoNeto && formatearNumero(miMontoNeto*75/100, false))
  setConvenioOld(montosInformados && isValidParam(montosInformados.montosInformados[0]['PorConvenio']) ? montosInformados.montosInformados[0]['PorConvenio'] : '' )
}*/
}, [montosInformados, datosCIATErcero])

useEffect(()=>{

  setFechaSiniestro(datosGestionImplicado && isValidParam(datosGestionImplicado.datosGestionImplicado[0]['fechaSiniestroFormat']) 
    ? datosGestionImplicado.datosGestionImplicado[0]['fechaSiniestroFormat'] : ''
  )  
  
},[datosGestionImplicado, fechaSiniestro])

  const convertirFecha = (fecha) => {
    if (fecha !== null && typeof fecha !== undefined) {
      const [dia, mes, ano] = fecha?.split('-')
      const fechaFormat = [ano, mes, dia].join('-')

      return fechaFormat
    } else return null
  }
  const handleOpen = () => {
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
  }
  const handleAction = (action) => {
    console.log(action)
  }
  const hoy = () => {
    const fecha = new Date()
    const hoy = fecha.toISOString().split('T')[0]
    return hoy
  }
  const handleCloseToast = () => {
    setShowToast(false);
  }
  const calculaMontoRecobro = (idCia) => {
    let cias = comboCompanias.comboCompanias?.filter(m => idCia !== "" && Number(m.id) === Number(idCia))
    if (cias && cias.length > 0) {
      let usoVh = datosCIATErcero && isValidParam(datosCIATErcero.datosCIATErcero[0]['usoVh']) ? datosCIATErcero.datosCIATErcero[0]['usoVh'] : 20001;
      let porcConvenio = cias[0].porcConvParticular;
      if (usoVh == 20002) {//“Publico/Comercial” (20002).
        porcConvenio = cias[0].porcConvPublico;
      }      
      
      setConvenio(porcConvenio);
      setPorcConvData(porcConvenio);
      let montoRecobro = miMontoNeto && Math.round(miMontoNeto * porcConvenio / 100);
      setMiRecobro(formatearNumero(montoRecobro, false));    
      setRecobroNoFormato(montoRecobro);  
      setMirecobroSinFormato(montoRecobro);
    }

  }
  return (
    <>
      <style type='text/css'>
        {`
    .btn-subir {
      background-color: #00aeab;
      color: #FFFFFF;   
      height:40px;

    }
    .btn-subir:hover{
        background-color:#01cec8;
        color: #FFFFFF;
        
    } 
    
    `}
      </style>

     
        <Card>
          <Card.Header
            className='mt-0 mb-0'
            as='h6'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            {cfg_form16
              ? cfg_form16.cfg_form16['cartaciatercero-title-gestion']
              : ''}
          </Card.Header>
          <Container>
            <Container>
              {cfg_form14 ? (
                <div>
                  <Row>
                    <Col md='2'>
                      <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-rut']}
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mt-3'>
                        {datosCIATErcero &&
                        datosCIATErcero.datosCIATErcero[0]['RutInvolucrado'] !==
                          undefined &&
                        datosCIATErcero.datosCIATErcero[0]['RutInvolucrado'] !==
                          null &&
                        datosCIATErcero.datosCIATErcero[0]['RutInvolucrado'] !==
                          ''
                          ? formato_rut(
                              datosCIATErcero.datosCIATErcero[0][
                                'RutInvolucrado'
                              ]
                            )
                          : ''}
                      </Form.Text>
                    </Col>
                    <Col>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-nombre']}
                      </Form.Label>
                      <br />
                      <Form.Text className='mt-3'>
                        {datosCIATErcero &&
                        datosCIATErcero.datosCIATErcero[0][
                          'NombreInvolucrado'
                        ] !== undefined &&
                        datosCIATErcero.datosCIATErcero[0][
                          'NombreInvolucrado'
                        ] !== null &&
                        datosCIATErcero.datosCIATErcero[0][
                          'NombreInvolucrado'
                        ] !== ''
                          ? datosCIATErcero.datosCIATErcero[0][
                              'NombreInvolucrado'
                            ]
                          : ''}
                      </Form.Text>
                    </Col>
                  </Row>

                  <Row>
                    <Col md='3'>
                      <Form.Label
                        className='mb-0 mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-tipovh']}
                      </Form.Label>{' '}
                      <br />
                      <Form.Select
                        className='mt-2'
                        aria-label='Default select example'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setTipoVehiculoIM(e.target.value)
                        }}
                        name='tipoVehiculoIM'
                        value={(formik.values.tipoVehiculoIM = tipoVehiculoIM)}
                        error={formik.errors.tipoVehiculoIM}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboTipoVehiculos &&
                          comboTipoVehiculos.comboTipoVehiculos?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {/* {formik.errors.tipoVehiculoIM ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.tipoVehiculoIM}
                    </Form.Text>
                  ) : (
                    ''
                  )} */}
                    </Col>
                    <Col md='2'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-patente'] +
                          ' *'}
                      </Form.Label>
                      <br />
                      <Form.Control
                        className='mb-0'
                        value={(formik.values.patenteIM = patenteIM)}
                        name='patenteIM'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setPatenteIM(e.target.value)
                        }}
                       error={formik.errors.patenteIM}
                      ></Form.Control>
                       {formik.errors.patenteIM ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.patenteIM}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                    <Col md='3'>
                      <Form.Label
                        className='mt-3'
                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                      >
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-marca']}
                      </Form.Label>
                      <br />
                      <Form.Select
                        aria-label='Default select example'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setMarcaVehiculoIM(e.target.value)
                        }}
                        name='marcaVehiculoIM'
                        value={
                          (formik.values.marcaVehiculoIM = marcaVehiculoIM)
                        }
                        error={formik.errors.marcaVehiculoIM}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboMarcas &&
                          comboMarcas.comboMarcas?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {/* {formik.errors.marcaVehiculoIM ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.marcaVehiculoIM}
                    </Form.Text>
                  ) : (
                    ''
                  )} */}
                    </Col>
                    <Col md='4'>
                      <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-descripcion']}
                      </Form.Label>
                      <br />
                      <Form.Control
                        as='textarea'
                        className='mb-2'
                        rows={2}
                        onChange={(e) => {
                          formik.handleChange(e)
                          setDetalleDescripcionIM(e.target.value)
                        }}
                        name='detalleDescripcionIM'
                        value={(formik.values.detalleDescripcionIM =detalleDescripcionIM)}
                        error={formik.errors.detalleDescripcionIM}
                      />
                      {formik.errors.detalleDescripcionIM ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.detalleDescripcionIM}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                    </Col>
                  </Row>

                  <hr
                    style={{
                      color: '#04005D',
                      height: '2px',
                      marginTop: '30px'
                    }}
                  ></hr>
                  <Row>
                    <Col md='3'>
                      <Form.Label className='mb-0 mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-ciaseguro'] + ' *'}
                      </Form.Label>{' '}
                      <br />
                      <Form.Select
                        className='mt-2'
                        aria-label='Default select example'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setIdCompaniaIM(e.target.value)
                          calculaMontoRecobro(e.target.value);
                        }}
                        name='idCompaniaIM'
                        value={(formik.values.idCompaniaIM = idCompaniaIM)}
                        error={formik.errors.idCompaniaIM}
                      >
                        <option value={''}>Seleccione...</option>
                        {comboCompanias &&
                          comboCompanias.comboCompanias?.map((c) => (
                            <option key={c.id} value={c.id}>
                              {c.nombre}
                            </option>
                          ))}
                      </Form.Select>
                      {formik.errors.idCompaniaIM ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.idCompaniaIM}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col md='3'>
                      <Form.Label className='mt-3'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-siniciatro'] + ' *'}
                      </Form.Label>
                      <br />
                      <Form.Control
                        className='mb-0'
                        value={(formik.values.idSiniestroIM = idSiniestroIM)}
                        name='idSiniestroIM'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setIdSiniestroIM(e.target.value)
                        }}
                         error={formik.errors.idSiniestroIM}
                      ></Form.Control>
                      {formik.errors.idSiniestroIM ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.idSiniestroIM}
                        </Form.Text>
                      ) : (
                        ''
                      )}
                    </Col>
                    <Col md='2'>
                      <Form.Label className='mt-3'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-fechasinitro']}
                      </Form.Label>
                      <br />
                      <Form.Control
                        className='mb-4'
                        type='date'
                        value={(formik.values.fechaSiniestroIM = fechaSiniestroIM)}
                        min={fechaSiniestro && parametros &&
                          diaAnterior(fechaSiniestro, parametros.parametros['valorParametro'])}
                        max={fechaSiniestro  && parametros && diaPosterior(fechaSiniestro, parametros.parametros['valorParametro'])}
                        name='fechaSiniestroIM'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setFechaSiniestroIM(e.target.value)
                        }}
                        // error={formik.errors.fechaSiniestroIM}
                      ></Form.Control>
                      {/* {formik.errors.fechaSiniestroIM ? (
                    <Form.Text variant='danger' style={{ color: 'red' }}>
                      {formik.errors.fechaSiniestroIM}
                    </Form.Text>
                  ) : (
                    ''
                  )}
                      */}
                    </Col>

                    <Col md='2'>
                      <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16['cartaciatercero-input-fechaenvcarta'] + ' *'}
                      </Form.Label>
                      <br />
                      <Form.Control
                        className='mb-0'
                        type='date'
                        value={(formik.values.fechaEnvioCarta = fechaEnvioCarta)}
                        min={fechaCartaMin && fechaCartaMin}
                        max={hoy()}
                        name='fechaEnvioCarta'
                        onChange={(e) => {
                          formik.handleChange(e)
                          setFechaEnvioCarta(e.target.value)
                        }}
                        error={formik.errors.fechaEnvioCarta}
                      ></Form.Control>
                      {formik.errors.fechaEnvioCarta ? (
                        <Form.Text variant='danger' style={{ color: 'red' }}>
                          {formik.errors.fechaEnvioCarta}
                        </Form.Text>
                      ) : (
                          ''
                      )}                     
                    </Col>                   
                  </Row>
                  <Row>
                    <Col md='3'>
                      <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }} >
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-moneda'] +' *'}
                      </Form.Label>{' '}
                      <br />
                      <Form.Text className='mt-3'>
                        {montosInformados && isValidParam (montosInformados.montosInformados[0]['GlosaMoneda']) ? 
                          montosInformados.montosInformados[0]['GlosaMoneda']
                          : ''
                        }
                      </Form.Text>
                    </Col>
                    <Col md='3'>
                      <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-mtoneto'] + ' *'}
                      </Form.Label>
                      <br />
                      <Form.Text className='mt-3'>
                        {montosInformados && isValidParam(montosInformados.montosInformados[0]['MontoPago']) ?     
                          formatearNumero(montosInformados.montosInformados[0]['MontoCosto'], 
                            !(isValidParam(montosInformados.montosInformados[0]['CodMoneda']) && montosInformados.montosInformados[0]['CodMoneda'] == 30001))   
                          : ''
                        }
                      </Form.Text>
                    </Col>
                    <Col md='2'>
                      <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16['cartaciatercero-input-porcconv'] + ' *'}
                      </Form.Label>
                      <br />
                      <Form.Text className='mt-3'>
                        {isValidParam (convenio) ? convenio                        
                          : ''
                        }
                      </Form.Text>
                    </Col>
                    <Col md='2'>
                      <Form.Label className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16[ 'cartaciatercero-input-mtorecobro'] + ' *'}
                      </Form.Label>
                      <br />
                      <Form.Text className='mt-3'>
                        {isValidParam(miRecobro) ? miRecobro : ''}
                      </Form.Text>
                    </Col>                                 
                  </Row>
                  <Row>
                    <Col md='10'>
                    <Form.Label  className='mt-3' style={{ fontWeight: 'bold', fontSize: '14px' }}>
                        {cfg_form16.cfg_form16['cartaciatercero-lbl-subirdcto']}
                      </Form.Label>
                      <Form.Group className="position-relative mb-2 mt-1">
                      <Form.Control ref={fileRef} type="file" name="file"
                          onChange={event => { formik.setFieldValue("file", event.currentTarget.files[0]); }} onBlur={formik.handleBlur}
                          isInvalid={!!formik.errors.file}
                          isValid={formik.touched.file && !formik.errors.file}
                      />
                      <Form.Text className="text-muted">Tamaño máximo del archivo: 10MB</Form.Text>
                      <Form.Control.Feedback type="invalid"> {formik.errors.file} </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col >
                    {respuestaModalCIA && 
                      <Mensajes
                          showToast={showToast}
                          handleCloseToast={handleCloseToast}
                          delay={5000}
                          responseData={respuestaModalCIA?.respuestaModalCIA}
                      ></Mensajes>
                    }
                   </Col>
                  </Row>
                  <hr
                    style={{
                      color: '#04005D',
                      height: '2px',
                      marginTop: '30px'
                    }}
                  ></hr>
                </div>
              ) : null}
            </Container>
          </Container>
        </Card>
      
    </>
  )
}

export default CartaCiaTercero
